module.exports = __webpack_public_path__ + "static/12-Broadcom-38fd3243fa5d86aea5c8fe3aed5e7354.png";